var render = function render(_c,_vm){return (_vm.props.month > 0)?_c('a',{style:({ color: _vm.$options.getColor(_vm.props) }),attrs:{"href":"#"},on:{"click":function($event){return _vm.$options.Selected(_vm.props)}}},[_vm._v(" "+_vm._s(_vm.$options.MothValue(_vm.props))+" ")]):_c('span',[_vm._v(_vm._s(_vm.$options.MothValue(_vm.props)))])
}
var staticRenderFns = []

export { render, staticRenderFns }